export default __webpack_public_path__ + "static/media/back-button.d07a3f11.svg";